export default "__VITE_ASSET__VZW4TPGI__"